import { render } from "./modal_allreglementbcd.vue?vue&type=template&id=70b26d8e&scoped=true"
import script from "./modal_allreglementbcd.vue?vue&type=script&lang=js"
export * from "./modal_allreglementbcd.vue?vue&type=script&lang=js"

import "./modal_allreglementbcd.vue?vue&type=style&index=0&id=70b26d8e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b26d8e"]])

export default __exports__